<template>
  <el-checkbox
    v-model="isChecked"
    :indeterminate="indeterminate"
    @change="handleCheckAllChange"
  />
</template>

<script>
export default {
  data() {
    return {
      isChecked: false,
      indeterminate: false
    }
  },
  computed: {
    rowData() {
      const { dataKey = 'rowData' } = this.params.context
      const rowData = this.params.context.componentParent[dataKey]
      return rowData
    }
  },
  watch: {
    rowData: {
      deep: true,
      handler() {
        this.handlerCheckedState()
      }
    }
  },
  methods: {
    handlerCheckedState() {
      let isChecked = false
      let indeterminate = false
      const { childrenListKey = '_details' } = this.params.context
      const { apiKey = 'gridApi' } = this.params.context
      const fatherApi = this.params.context.componentParent[apiKey]
      const fatherId = this.params.api.getRowNode('0').data.parentId
      const fatherInfo = fatherApi.getRowNode(fatherId)
      if (!fatherInfo || !fatherInfo.data) { isChecked = false }
      isChecked = fatherInfo.data._selectedKeys.length === fatherInfo.data[childrenListKey].length
      this.isChecked = isChecked
      if (isChecked) indeterminate = false
      else indeterminate = !fatherInfo ? false : (fatherInfo.data._selectedKeys && !!fatherInfo.data._selectedKeys.length) || fatherInfo.data._selected
      this.indeterminate = indeterminate
    },
    handleCheckAllChange(e) {
      const { childrenListKey = '_details', apiKey = 'gridApi', childRowKey } = this.params.context
      const fatherApi = this.params.context.componentParent[apiKey]
      const fatherId = this.params.api.getRowNode('0').data.parentId
      const fatherInfo = fatherApi.getRowNode(fatherId)
      fatherInfo.data._selected = e
      if (e && fatherInfo.data[childrenListKey]) {
        fatherInfo.data._selectedKeys = fatherInfo.data[childrenListKey].map(item => {
          if (!item._selectedDisabled) {
            return item[childRowKey]
          }
        })
      } else {
        fatherInfo.data._selectedKeys = []
      }
      const id = `detail_${fatherInfo.id}`
      const rowNode = fatherApi.getDetailGridInfo(id)
      const parentTabel = this.$parent.$el
      const parentEl = parentTabel.querySelector(`[row-id="${id}"] .ag-details-row`)
      if (parentEl) {
        const operate = e ? 'add' : 'remove'
        Array.from(parentEl.children).forEach(item => item.classList[operate](...['ag-row-focus', 'ag-row-selected']))
      }
      rowNode && rowNode.api.refreshCells({ force: true })
      fatherApi.refreshCells({ force: true })
    }
  }
}
</script>
